import s from"../packages/web-components/src/utils/data/naics-codes.json.js";function l(){let o=s,e=[];for(let[t,r]of Object.entries(o))e.push({value:t,label:t+" - "+r});return e}export{l as formattedNaicsCodes};
